
import cn from "classnames";
import styles from "./TableAndSearchMaster.module.scss";
// import Table from "./Table";
import NewTableFilter from "./NewTableFilter";
import React, {
  useState,
  useEffect,
  useRef,
  //   Component,
  //   useCallback,
} from "react";

import { useLocation } from 'react-router-dom';

var noData = [];

export default function NewTableList(props) {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [resetText, setResetText] = useState(false);
  const [currentPageLimit, setCurrentPageLimit] = useState(10);
  const [filterAction, setFilterAction] = useState([0, 1]); //filterAction[0] => 0 for start, 1 for reset, 2 for apply, filterAction[1] => for changin
  const [filterChange, setFilterChange] = useState(true);
  var tempBtnType;

  const scrollRef = useRef(null);
  const scrollFun = () => {
    scrollRef?.current?.scrollTo(0, 0);
  };

  useEffect(() =>{
  // tempBtnType = localStorage.getItem("headerBtnType");
  // const valueCheck = localStorage.getItem("lastTableSearch")
  // searchOnFilter(0, 10, props.tigger, typeof valueCheck === "object" ? "" : valueCheck);
  searchOnFilter();
  // if(tempBtnType == "reset" || tempBtnType =="apply" ) {
  //   setFilterAction([2, filterAction[1] == 0 ? 1 : 0, !filterChange?0:1]);
  // } else {
  //   setFilterAction([1, filterAction[1] == 0 ? 1 : 0, !filterChange?0:1]);
  // }

  
   
},[props.tigger]);
   

  const paginator = (page, pageSize, searchString) => {
    searchOnFilter(searchString, page, pageSize);
  };
  const searchOnFilter = (searchString, page, pageSize) => {
    console.log(searchString, page, pageSize,"searchString, page, pageSize")
    if (searchString === undefined || searchString === "") {
      setResetText(!resetText);
    }

    if (splitLocation[1] === 'ServiceRequest') {
      props?.searchOpts && props.searchOpts?.onFilterSearch && props.searchOpts?.onFilterSearch(
        (
          (pageSize === undefined || typeof parseInt(pageSize) !== "number"
          ? "&limit=" + currentPageLimit
          : "&limit=" + pageSize)
          +
          (page === undefined || typeof parseInt(page) !== "number"
        ? "&offset=0"
        : "&offset=" + page)
        )
        )
    }
    else if (splitLocation[1] === 'Pricing') {
      props.searchOpts && props.searchOpts?.onFilterSearch(
        (page === undefined || page === ""
          ? "&pageNumber=1"
          : "pageNumber=" + ++page) +
        (pageSize === undefined || typeof parseInt(pageSize) !== "number"
          ? "&pageSize=" + currentPageLimit
          : "&pageSize=" + pageSize))
    }
  };
  return (
    <div className={cn(styles.box16, styles.box16_layout)}>
      {/* <Table columns={props.columns} data={props.data} /> */}
      {props?.data?.length < 1 || props?.data == null ? (
        <div style={{ overflowX: "auto" }}>
          <NewTableFilter
            columns={props.columns}
            data={noData}
            paginationDoubleScreen={props.paginationDoubleScreen}
          />
          {/* no_data_found_container */}
          <div className={cn(styles.no_data_found_container)}>
            <img
              src={require("assets/Search_No_data_Found.svg").default}
              height={"60px"}
              width={"60px"}
            ></img>
            <h5 className={cn(styles.no_data_found_label)}>
              No Record Found
            </h5>
          </div>
        </div>
      ) : (
        <div ref={scrollRef} 
        // style={{ overflowX: "auto" }}
        >
          <NewTableFilter
            columns={props.columns}
            data={props.data}
            scroll={scrollFun}
            // pageLimitHandle={props.pageLimitHandle}
              // filterAction={filterAction}
            pageLimitHandle={paginator}
            paginationDoubleScreen={props.paginationDoubleScreen}
            swapStationCount={props.swapStationCount}
            setCurrentPageLimit={setCurrentPageLimit}
            tigger={props.tigger}
            paginationCountHanlde={props?.paginationCountHanlde}
          />
        </div>
      )}
    </div>

  );
}
